import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  EVENTO_ABRIR_CHAT,
  getPermissionState,
  isSoundEnabled,
  jaPerdeuNotificacao,
  requestPermission,
  setSoundEnabled,
  setUnreadCount,
  startBadge,
  stopBadge,
  subscribePermission,
  subscribeSound,
} from 'src/services/notifications';
import { PATH_CHAT } from 'src/routes/paths';

/** Estado da permissao de notificacao + acao de pedir (so a partir de gesto). */
export function usePermissaoNotificacao() {
  const [estado, setEstado] = useState(getPermissionState);
  const [perdeuNotificacao, setPerdeu] = useState(jaPerdeuNotificacao);

  useEffect(
    () =>
      subscribePermission((proximo) => {
        setEstado(proximo);
        setPerdeu(jaPerdeuNotificacao());
      }),
    []
  );

  const pedir = useCallback(async () => {
    const resultado = await requestPermission();
    setEstado(resultado);
    return resultado;
  }, []);

  return { estado, perdeuNotificacao, pedir };
}

/**
 * Toggle de som compartilhado. As telas antigas liam o localStorage direto e
 * chamavam window.location.reload() para o resto do app enxergar a mudanca — o
 * reload derrubava o socket e o estado de digitacao.
 */
export function useSomNotificacao() {
  const [ligado, setLigado] = useState(isSoundEnabled);

  useEffect(() => subscribeSound(setLigado), []);

  const alternar = useCallback((valor) => {
    const proximo = typeof valor === 'boolean' ? valor : !isSoundEnabled();
    setSoundEnabled(proximo);
    setLigado(proximo);
    return proximo;
  }, []);

  return { ligado, alternar };
}

/** Clique na notificacao abre a conversa, sem recarregar a pagina. */
export function useAbrirChatDaNotificacao() {
  const navigate = useNavigate();

  useEffect(() => {
    const abrir = (evento) => {
      const chatId = evento?.detail?.chatId;
      if (!chatId) return;
      navigate(`${PATH_CHAT.chat.root}/${chatId}`);
    };
    window.addEventListener(EVENTO_ABRIR_CHAT, abrir);
    return () => window.removeEventListener(EVENTO_ABRIR_CHAT, abrir);
  }, [navigate]);
}

/** Contador de nao lidos no titulo da aba e no favicon. */
export function useBadgeNaoLidos() {
  const pendentes = useSelector((state) => state.chat?.countsListaChats?.count_pendente || 0);
  const naoLidosAtendendo = useSelector(
    (state) => (state.chat?.chatsAtendimento || []).filter((c) => c?.novaMensagem === 'sim').length
  );
  const salasInternas = useSelector((state) => (state.staff?.roomsWithNewMessages || []).length);

  useEffect(() => {
    startBadge();
    return stopBadge;
  }, []);

  useEffect(() => {
    setUnreadCount(pendentes + naoLidosAtendendo + salasInternas);
  }, [pendentes, naoLidosAtendendo, salasInternas]);
}
